<ngu-carousel
  class="vr-carousel mx-auto {{ classWidth() }}"
  #myCarousel
  [inputs]="carouselTileConfig()"
  [dataSource]="vrMedia()"
>
  <ngu-tile class="" *nguCarouselDef="let item; let i = index">
    <div class="content-card" style="height: 250px">
      <app-vr-card [itemVr]="item" />
    </div>
  </ngu-tile>

  <a
    NguCarouselPrev
    class="carousel-control-prev"
    role="button"
    [style.opacity]="myCarousel.isFirst() ? 1 : 1"
  >
    <div class="relleno">
      <span class="carousel-control-prev-icon c-c-p-i-w" aria-hidden="true"></span>
    </div>
  </a>

  <a
    NguCarouselNext
    class="carousel-control-next"
    role="button"
    [style.opacity]="myCarousel.isLast() ? 1 : 1"
  >
    <div class="relleno">
      <span class="carousel-control-next-icon c-c-n-i-w" aria-hidden="true"></span>
    </div>
  </a>

  <ul class="myPoint" NguCarouselPoint>
    @for (item of myCarousel.pointNumbers(); track item) {
      <li
        [class.active]="$index == myCarousel.activePoint()"
        (click)="myCarousel.moveTo($index)"
      ></li>
    }
  </ul>
</ngu-carousel>
